export const getNameSelector = (state) =>
    state.persistUser && state.persistUser.name;
export const getPhoneSelector = (state) =>
    state.persistUser && state.persistUser.phone;
export const getAddressSelector = (state) =>
    state.persistUser && state.persistUser.address;
